import { FC } from 'react';
import { Avatar, Tooltip } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { isNil } from '@robocorp/robocloud-shared-utils';

type OwnProps = {
  party?: {
    name?: string;
    // eslint-disable-next-line camelcase
    details?: { picture?: string; first_name?: string; last_name?: string };
  };
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
  showName?: boolean;
  subtitle?: string;
  initials?: string;
  isCurrentUser?: boolean;
};
type Props = OwnProps;

const getAvatarColor = (name: string) => {
  const colors = ['blue', 'green', 'purple', 'magenta', 'teal', 'orange', 'red'] as const;
  const charCode = name.length > 0 ? name.charCodeAt(0) : 0;
  return colors[charCode % colors.length];
};

const PartyAvatar: FC<Props> = ({
  party,
  showTooltip,
  showName,
  isCurrentUser,
  initials: defaultInitials,
  ...rest
}) => {
  const { t } = useTranslation();

  const getPartyName = (): string => {
    if (isNil(party?.details?.first_name) && isNil(party?.details?.last_name)) {
      return t('noName');
    }

    const fullName = `${party?.details?.first_name} ${party?.details?.last_name}`;

    return isCurrentUser ? `${fullName} (${t('you')})` : fullName;
  };

  const partyName = getPartyName();

  const initials = defaultInitials || partyName.charAt(0);
  const variant = getAvatarColor(initials);

  return (
    <Tooltip text={showTooltip ? partyName : undefined}>
      <Avatar
        placeholder={initials}
        alt={partyName}
        src={party?.details?.picture || ''}
        variant={variant}
        title={showName ? partyName : undefined}
        {...rest}
      />
    </Tooltip>
  );
};

PartyAvatar.defaultProps = {
  size: 'medium',
};

export default PartyAvatar;
